import api from "./api";
import Cookies from 'js-cookie';

interface LoginResponse {
  token: string;
  user: {
    id: string;
    username: string;
  };
}

export const getProfile = (): { id: string; username: string } | null => {
  const token = Cookies.get('auth_token');
  const username = Cookies.get('session_user');
  const id    = Cookies.get('session_id') ?? '';

  if (!token || !username) return null;

  return { id, username };
};

export const login = async (username: string, password: string): Promise<LoginResponse> => {
  try {
    const response = await api.post<LoginResponse>('/auth', { username, password });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(error.response.data.message || 'Invalid username or password');
    } else if (error.request) {
      throw new Error('No response from server. Please try again.');
    } else {
      throw new Error('Login failed. Please try again.');
    }
  }
};

export const logout = async () => {
  // try {
  //   await api.post('/auth/logout');
  // } catch (error: any) {
  //   console.warn('Logout error:', error.response?.data || error.message);
  // }
};